import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=576a5dba&scoped=true"
import script from "./DashboardReport.vue?vue&type=script&lang=ts"
export * from "./DashboardReport.vue?vue&type=script&lang=ts"
import style0 from "./DashboardReport.vue?vue&type=style&index=0&id=576a5dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576a5dba",
  null
  
)

export default component.exports